import { Phone, MessageCircle, CalendarDays } from "lucide-react";
import { Link } from "react-router-dom";

export default function StickyMobileCTA() {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden flex border-t border-white/10 bg-[#0A0A0A]/95 backdrop-blur-xl"
    >
      <a
        href="tel:+393784035054"
        data-testid="sticky-call-btn"
        className="flex-1 flex flex-col items-center justify-center gap-1 py-3 text-white hover:text-[#C9A646] transition-colors"
      >
        <Phone className="w-5 h-5" strokeWidth={1.5} />
        <span className="text-[10px] tracking-wider uppercase font-medium">Chiama</span>
      </a>
      <a
        href="https://wa.me/393784035054?text=Salve%2C%20vorrei%20richiedere%20informazioni%20sul%20servizio%20NCC."
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp-btn"
        className="flex-1 flex flex-col items-center justify-center gap-1 py-3 bg-[#C9A646] text-[#0A0A0A] hover:bg-[#E1C16E] transition-colors"
      >
        <MessageCircle className="w-5 h-5" strokeWidth={1.5} />
        <span className="text-[10px] tracking-wider uppercase font-medium">WhatsApp</span>
      </a>
      <Link
        to="/prenota"
        data-testid="sticky-book-btn"
        className="flex-1 flex flex-col items-center justify-center gap-1 py-3 text-white hover:text-[#C9A646] transition-colors"
      >
        <CalendarDays className="w-5 h-5" strokeWidth={1.5} />
        <span className="text-[10px] tracking-wider uppercase font-medium">Prenota</span>
      </Link>
    </div>
  );
}
